import { useCompetitionRegistrationCategorySummaryQuery } from '~/pages/competition/set-category/queries';
import { Schema } from './register-lifter-form-schema';
import { useFormContext } from 'react-hook-form';
import { useParams } from '~/hooks/useParams';
import { Input } from '~/components/Input';
import { idParamSchema } from '~/schemas';
import { useMemo } from 'react';

export function RegisterLifterCompetitionType() {
  const { formState, register, watch } = useFormContext<Schema>();
  const { id } = useParams(idParamSchema.parse);

  // Only rendered for regular competitions — team comps register by team alone and don't use
  // registration categories (the summary is empty for them anyway).
  const { data = [], isLoading } = useCompetitionRegistrationCategorySummaryQuery(id);

  const options = useMemo(() => {
    return data.map(d => [d.competition_type.description, d.competition_type.id] as [string, number]);
  }, [data]);

  return (
    <Input.Select
      defaultValue={watch('competition_type_id') ?? undefined}
      {...register('competition_type_id')}
      placeholder="Välj tävlingstyp"
      formState={formState}
      disabled={isLoading}
      options={options}
    />
  );
}
